import React from 'react'
import './services.css'
import HeartEmoji from "../../img/heartemoji.png"
import Glasses from "../../img/glasses.png"
import Humble from "../../img/humble.png"
import Card  from "../Card/Card"

const Services = () => {
  return (
    <div className="services" id='services'>
      <div className="awesome">
        <span>My Awesome</span>
        <span>services</span>
        <span>
            I offer tailored web design and development services
            <br/>
            that create engaging, user-friendly digital experiences.
        </span>
        <div className="blur s-blurl" style={{ background: "#ABF1FF94"}}></div>

      </div>

      <div className="cards">

       <div style={{left: '11rem', top: '7rem'}}
       >
         <Card
         emoji= {HeartEmoji}
         heading = {'Design'}
         detail = {"Sketch, Photoshop, Adobe, Adobe xd"}
         />
         </div>

           <div style={{top: "14rem", left: "-4rem"}}>
             <Card 
             emoji={Glasses}
             heading={'Developer'}
             detail={"Html, Css, JavaScript, React,c, c++"}
             />
            </div>

            <div style={{top: "14rem", left: "26rem"}}>
                <Card 
                emoji={Humble}
                heading={"UI/UX"}
                detail={"Crafting seamless and engaging user experiences that enhance usability."}
                />
            </div>

            <div className="blur s-blur2" style={{ background: "var(--purple)"}}></div>



         </div>
    </div>
  )
}

export default Services

